import { useAuth } from '@/context/AuthContext'
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { Selection } from 'BrokerTsLib/src/enums/Selection'
import { useEffect, useMemo, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

export const PolicyHolderSameAsAcquirerWarning = () => {
    const { user } = useAuth()
    const { watch } = useFormContext<InsuranceParamsDto>()
    const phType = watch('policyHolder.person.type')
    const email = watch('policyHolder.person.email')
    const firstName = watch('policyHolder.person.name')
    const lastName = watch('policyHolder.person.surname')
    const ico = watch('policyHolder.person.idendificationNumber')
    const sameAcquirerAndPolicyHolder = useMemo(() => {
        if (phType == Selection.Person) {
            const currentUserKey = `${user?.email},${user?.firstName},${user?.lastName}`
            const policyHolderKey = `${email},${firstName},${lastName}`

            if (currentUserKey === policyHolderKey)
                return true
        }
        else {
            if (user?.ico == ico)
                return true
        }
    }, [user, ico, phType, email, firstName, lastName])

    const { isOpen, onOpen, onClose } = useDisclosure()
    const alreadyOpenedRef = useRef(false)
    useEffect(() => {
        if (sameAcquirerAndPolicyHolder && !alreadyOpenedRef.current) {
            alreadyOpenedRef.current = true
            onOpen()
        }
    }, [sameAcquirerAndPolicyHolder, onOpen])

    return <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
        <ModalOverlay />

        <ModalContent>
            <ModalCloseButton />

            <ModalHeader>Shoda poradce a pojistníka</ModalHeader>

            <ModalBody py={0}>
                Byla detekována shoda poradce s pojistníkem/klientem. <br/> Samosjednání pojistné smlouvy není povoleno. <br/> Nabídku je možné vytvořit, ale nebude možné ji uzavřít.
            </ModalBody>

            <ModalFooter>
                <Button colorScheme="primary" onClick={onClose}>
                    Rozumím
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
}
